// stores/promptStore.ts
import { create } from 'zustand';
import { Prompt } from '@/lib/types/prompt';

interface PromptStore {
  latestPrompt: Prompt | null;
  setLatestPrompt: (prompt: Prompt) => void;
  clearPrompt: () => void;
}

export const usePromptStore = create<PromptStore>((set) => ({
  latestPrompt: null,
  setLatestPrompt: (prompt) => set({ latestPrompt: prompt }),
  clearPrompt: () => set({ latestPrompt: null }),
}));
